import { Component, effect, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { AuthService } from "./shared/services/auth/auth.service";

import { Observable, filter, map, of } from "rxjs";

import { NewVersionCheckerService } from "./shared/services/version/version.service";

import { MessageService } from "primeng/api";

import { Select, Store } from "@ngxs/store";
import { User } from "./shared/state/user/user.actions";
import { ApiErrorState } from "./shared/state/api_error/api_error.state";
import { Organization } from "./shared/state/organization/organization.actions";
import { Organization as OrganizationModel } from "./shared/models/organization/organization.model";
import { OrganizationState } from "./shared/state/organization/organization.state";
import { UiState } from "./shared/state/ui/ui.state";
import { Ui } from "./shared/state/ui/ui.actions";

import { WebsocketService } from "./shared/services/websocket/websocket.service";

//Signal
import { firstSetup } from "./shared/signals/first-setup";
import { ApiErros } from "./shared/state/api_error/api_error.actions";
import { HttpErrorResponse } from "@angular/common/http";
import { LocationDevices } from "./shared/state/location_devices/location_devices.actions";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
	standalone: false,
})
export class AppComponent implements OnInit {
	$isSidebarCollapsed: Observable<boolean>;
	$isAuthenticated: Observable<boolean> = of(false);

	firstSetup = firstSetup;
	isFirstSetup: boolean;
	@Select(OrganizationState.getOrganization) $organization: Observable<OrganizationModel>;

	@Select(ApiErrorState.errors) $errors: Observable<any>;
	errors: any[] = [];

	constructor(
		private authService: AuthService,
		private store: Store,
		public versionService: NewVersionCheckerService,
		private router: Router,
		private wsService: WebsocketService
	) {
		effect(() => {
			this.isFirstSetup = firstSetup();
		});
	}

	ngOnInit() {
		// Global Error message
		// this.$errors.subscribe((errors: any) => {
		// 	let keys = Object.keys(errors);

		// 	if (keys.length == 0) {
		// 		this.errors = [];
		// 		return;
		// 	}

		// 	Object.entries(errors).map((e) => {
		// 		const err: HttpErrorResponse = e[1] as HttpErrorResponse;
		// 		console.log(err);
		// 		const severity = err.status === 404 ? "warn" : "error";
		// 		this.errors.push({
		// 			key: e[0],
		// 			severity: severity,
		// 			content: err.message,
		// 		});
		// 	});
		// });

		this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => {
			this.clearErrors();
		});
		this.$isAuthenticated = this.authService.isAuthenticated$;

		this.$isAuthenticated.subscribe((isAuthenticated) => {
			this.store.dispatch(new User.Fetch());

			this.wsService.connect();
		});

		this.store.dispatch(new Organization.Fetch());

		this.$isSidebarCollapsed = this.store.select(UiState.sidebarOpen).pipe(map((open: boolean) => !open));

		this.wsService.onMessage().subscribe({
			next: (data: any) => {
				if (!data || data.message) return;

				this.store.dispatch(
					new LocationDevices.UpdateDeviceState(
						data.location_id,
						data.device_id,
						data.event.component,
						data.event.capability,
						data.event.attribute,
						data.event.value,
						data.event.created_at
					)
				);
			},
		});
	}

	reload() {
		window.location.reload();
	}

	logout() {
		this.authService.logout();
	}

	reset() {
		// this.store.reset(null);
		this.store.dispatch(new Organization.ResetState());
	}

	onSidebarToggle() {
		this.store.dispatch(new Ui.ToggleSidebar());
	}

	errorsArray(errors: any) {
		return Object.keys(errors);
	}

	clearErrors() {
		this.store.dispatch(new ApiErros.ClearErrors());
	}

	removeError(key: any) {
		console.log(key);
		this.store.dispatch(new ApiErros.RemoveError(key));
	}
}
